/**
 * @namespace toolkit.constants
 */

  /**
 * @class toolkit.constants.EventConsts
 * @classdesc An event constants.
 */
export class EventConsts {

    /**
     * The reload grid event name.
     * @member {string} toolkit.constants.EventConsts#reloadGridEvent
     */     
    public static reloadGridEvent: string = 'reloadGrid';
}


// WEBPACK FOOTER //
// ./src/constants/eventConsts.ts